import { createFileRoute } from '@tanstack/react-router'
import { parseFocus, ProvidersTab } from '@/features/settings'

/** C-08 Providers; `focus` (a row id from a C-05 arrow) scrolls to and flashes that row (Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/booking/providers')({
  validateSearch: parseFocus,
  component: function ProvidersRoute() {
    const { focus } = Route.useSearch()
    return <ProvidersTab focus={focus} />
  },
})
